import { Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { ACCION_ACTUALIZAR, ACCION_PROCESAR } from "../utils/data";
import {
  actualizarTramite,
  buscarTramite,
  cancelarTramite,
  procesarTramite,
} from "../api/Tramite";
import { useAuthentication } from "../context/Authentication";
import { setInvalidFieldTouched } from "../utils/forms";
import { useNavigate } from "react-router-dom";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";

import { useDialog } from "./controls/Dialog";
import Loader from "./controls/Loader";
import Anchor from "./controls/Anchor";
import Alert from "./controls/Alert";
import Button from "./controls/Button";
import { TramiteSchema } from "../data/TramiteSchema";
import { EstadoTramite, TipoTramite } from "../utils/enums";
import TramiteIndex, { INDICE } from "./TramiteIndex";

export default function TramiteForm({ ...props }) {
  const { tramite, setTramite } = useTramite();
  const { t } = useTranslation();
  const { token } = useAuthentication();
  const [seccionActiva, setSeccionActiva] = useState(null);
  const [moduloActivo, setModuloActivo] = useState(INDICE[0]);
  const [loading, setLoading] = useState(!tramite);
  const [alert, setAlert] = useState([]);
  const navigate = useNavigate();
  const dialog = useDialog({ showing: false, variant: "warning" });
  const guardarTramite = (tramiteForm) => {
    setLoading(true);
    const value = TramiteSchema.cast(tramiteForm.values, {
      assert: false,
      context: { action: ACCION_ACTUALIZAR },
    });
    actualizarTramite(value, token).then(() => {
      buscarTramite(value.numero, token)
        .then((tramite) => {
          setTramite(tramite);
          setAlert({
            message: t("tramiteForm.guardado"),
            variant: "success",
            showing: true,
          });
        })
        .catch(error => {
          setAlert({
            message: t("tramiteForm.errorGuardado"),
            variant: "danger",
            showing: true,
          })
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  const finalizarTramite = (tramiteForm) => {
    tramiteForm.setFieldValue("accion", ACCION_PROCESAR);
    tramiteForm.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        setLoading(true);
        procesarTramite(tramiteForm.values, EstadoTramite.FINALIZADO, token)
          .then((tramite) => {
            setTramite(tramite);
            setAlert({
              message: t("tramiteForm.finalizado"),
              variant: "success",
              showing: true,
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setAlert({
          message: t("tramiteForm.validationError"),
          variant: "danger",
          showing: true,
        });
        tramiteForm.setErrors(errors);
        Object.keys(errors).forEach((field) => {
          setInvalidFieldTouched(field, errors[field], tramiteForm, true);
        });
      }
    });
  };
  const presentarTramite = (tramiteForm) => {
    tramiteForm.setFieldValue("accion", ACCION_PROCESAR);
    tramiteForm.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        setLoading(true);
        procesarTramite(tramiteForm.values, EstadoTramite.PRESENTADO, token)
          .then((tramite) => {
            setTramite(tramite);
            setAlert({
              message: t("tramiteForm.presentado"),
              variant: "success",
              showing: true,
            });
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setAlert({
          message: t("tramiteForm.validationError"),
          variant: "danger",
          showing: true,
        });
        tramiteForm.setErrors(errors);
        Object.keys(errors).forEach((field) => {
          setInvalidFieldTouched(field, errors[field], tramiteForm, false);
        });
      }
    });
  };
  const handleIndiceClick = (modulo, seccion) => (event) => {
    event.preventDefault();
    setModuloActivo((anterior) =>
      !seccion && anterior?.id === modulo.id ? anterior : modulo,
    );
    setSeccionActiva((anterior) =>
      !modulo.secciones
        ? null
        : !seccion
        ? null
        : anterior?.id === seccion.id
        ? anterior
        : seccion,
    );
  };
  return (
    <Loader loading={loading}>
      <Formik
        initialValues={tramite}
        enableReinitialize={true}
        validateOnChange={true}
        validationSchema={TramiteSchema}
        initialStatus="loaded"
      >
        {(tramiteForm) => (
          <>
            {console.debug(tramiteForm.errors)}
            {dialog.component}
            <h4 style={{ textAlign: "right" }}>
              {t("tramiteForm.titulo")
                .replace("{tipo}", tramite?.tipo?.nombre)
                .replace("{numero}", tramite?.numero)}
            </h4>
            <hr />
            <Grid>
              {/* {console.debug(tramiteForm.errors)}
              {console.debug(tramiteForm.values)} */}
              <Row>
                <Col lg={4}>
                  <TramiteIndex
                    moduloActivo={moduloActivo}
                    seccionActiva={seccionActiva}
                    setModuloActivo={setModuloActivo}
                    setSeccionActiva={setSeccionActiva}
                  />
                </Col>
                <Col lg={8}>
                  <Grid>
                    <Row>
                      <Col>
                        <div className="tab-content">
                          {INDICE.map((modulo) => (
                            <>
                              {!!modulo.secciones &&
                                modulo.secciones.length > 0 &&
                                modulo.isEnabled(tramiteForm) &&
                                modulo.secciones.map((seccion) => (
                                  <div
                                    id={`${modulo.id}_${seccion.id}`}
                                    className={[
                                      "tab-pane",
                                      "fade in",
                                      (moduloActivo?.id === modulo.id &&
                                        seccionActiva?.id === seccion.id &&
                                        "active") ||
                                        "",
                                    ]
                                      .join(" ")
                                      .trim()}
                                  >
                                    <h3>
                                      {t(
                                        `tramiteForm.indice.${modulo.id}.titulo`,
                                      )}
                                      &nbsp;-&nbsp;
                                      {t(
                                        `tramiteForm.indice.${modulo.id}.descripcion`,
                                      )}
                                    </h3>
                                    <hr />
                                    <h4>
                                      {t(
                                        `tramiteForm.indice.${modulo.id}.${seccion.id}`,
                                      )}
                                    </h4>
                                    <br />
                                    {!!seccion.component && (
                                      <>{seccion.component}</>
                                    )}
                                  </div>
                                ))}
                              {!seccionActiva && !!moduloActivo && (
                                <div
                                  id={`${modulo.id}`}
                                  className={[
                                    "tab-pane",
                                    "fade in",
                                    (moduloActivo?.id === modulo.id &&
                                      "active") ||
                                      "",
                                  ]
                                    .join(" ")
                                    .trim()}
                                >
                                  <h3>
                                    {t(
                                      `tramiteForm.indice.${modulo.id}.titulo`,
                                    )}
                                    &nbsp;-&nbsp;
                                    {t(
                                      `tramiteForm.indice.${modulo.id}.descripcion`,
                                    )}
                                  </h3>
                                  <hr />
                                  {!!modulo.component &&
                                    modulo.isEnabled(tramiteForm) && (
                                      <>{modulo.component}</>
                                    )}
                                  {!modulo.component &&
                                    modulo.isEnabled(tramiteForm) &&
                                    modulo.secciones &&
                                    !seccionActiva && (
                                      <>
                                        <ul>
                                          <ul className="nav nav-pills nav-stacked">
                                            {modulo.secciones.map((seccion) => (
                                              <li>
                                                <Anchor
                                                  onClick={handleIndiceClick(
                                                    modulo,
                                                    seccion,
                                                  )}
                                                  href={`#${modulo.id}_${seccion.id}`}
                                                  className={[
                                                    "text-small",
                                                    moduloActivo?.id ===
                                                      modulo.id &&
                                                    seccionActiva?.id ===
                                                      seccion.id
                                                      ? "active"
                                                      : "",
                                                    (seccion.isInvalid(
                                                      tramiteForm,
                                                    ) &&
                                                      "has-error") ||
                                                      "",
                                                  ]
                                                    .join(" ")
                                                    .trim()}
                                                  disabled={
                                                    !seccion.isEnabled(
                                                      tramiteForm,
                                                    )
                                                  }
                                                >
                                                  {t(
                                                    `tramiteForm.indice.${modulo.id}.${seccion.id}`,
                                                  ).toUpperCase()}
                                                </Anchor>
                                              </li>
                                            ))}
                                          </ul>
                                        </ul>
                                      </>
                                    )}
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <hr />
                        {alert.showing && (
                          <Alert
                            variant={alert.variant}
                            dismissable={true}
                            onClose={(event) => {
                              event.preventDefault();
                              setAlert({ ...alert, showing: false });
                            }}
                          >
                            <p>{alert.message}</p>
                          </Alert>
                        )}
                        <span
                          style={{
                            float: "right",
                            alignContent: "center",
                          }}
                        >
                          {[
                            EstadoTramite.FINALIZADO,
                            EstadoTramite.PENDIENTE,
                          ].indexOf(tramite?.estado?.codigo) >= 0 && (
                            <Button
                              variant="danger"
                              value={t("tramiteForm.cancelar")}
                              onClick={(event) => {
                                event.preventDefault();
                                dialog.display(
                                  t(
                                    "messages.establecimiento.eliminarTramite.title",
                                  ),
                                  t(
                                    "messages.establecimiento.eliminarTramite.value",
                                  ),
                                  t("tramiteForm.eliminar.accept"),
                                  t("tramiteForm.eliminar.decline"),
                                  () => {
                                    cancelarTramite(tramite.numero, token).then(
                                      () => {
                                        dialog.close();
                                        navigate("/");
                                      },
                                    );
                                  },
                                  () => {
                                    dialog.close();
                                  },
                                );
                              }}
                            />
                          )}
                          {[
                            EstadoTramite.PENDIENTE,
                            EstadoTramite.INICIADO,
                          ].indexOf(tramite?.estado?.codigo) >= 0 && (
                            <Button
                              variant="primary"
                              value={t("tramiteForm.guardar")}
                              disabled={tramiteForm.touched.length === 0}
                              onClick={(event) => {
                                event.preventDefault();
                                guardarTramite(tramiteForm);
                              }}
                            />
                          )}
                          {[
                            EstadoTramite.PENDIENTE,
                            EstadoTramite.INICIADO,
                          ].indexOf(tramite?.estado?.codigo) >= 0 &&
                            tramite?.tipo?.codigo === TipoTramite.DJG && (
                              <Button
                                variant="success"
                                value={t("tramiteForm.finalizar")}
                                onClick={(event) => {
                                  event.preventDefault();
                                  finalizarTramite(tramiteForm);
                                }}
                              />
                            )}
                          {(tramite?.estado?.codigo ===
                            EstadoTramite.FINALIZADO ||
                            (tramite?.estado?.codigo ===
                              EstadoTramite.PENDIENTE &&
                              tramite?.tipo?.codigo !== TipoTramite.DJG)) && (
                            <Button
                              variant="success"
                              value={t("tramiteForm.presentar")}
                              onClick={(event) => {
                                event.preventDefault();
                                presentarTramite(tramiteForm);
                              }}
                            />
                          )}
                          {[
                            EstadoTramite.PRESENTADO,
                            EstadoTramite.APROBADO,
                          ].indexOf(tramite?.estado?.codigo) >= 0 && (
                            <Button
                              variant="default"
                              value={t("tramiteForm.volver")}
                              onClick={(event) => {
                                event.preventDefault();
                                navigate("/");
                              }}
                            />
                          )}
                          {[
                            EstadoTramite.PRESENTADO,
                            EstadoTramite.APROBADO,
                          ].indexOf(tramite?.estado?.codigo) < 0 && (
                            <Button
                              variant="default"
                              value={t("tramiteForm.volver")}
                              onClick={(event) => {
                                event.preventDefault();
                                dialog.display(
                                  t("tramiteForm.messages.salir.title"),
                                  t("tramiteForm.messages.salir.value"),
                                  t("tramiteForm.salir.accept"),
                                  t("tramiteForm.salir.decline"),
                                  () => {
                                    dialog.close();
                                    navigate("/");
                                  },
                                  () => {
                                    dialog.close();
                                  },
                                );
                              }}
                            />
                          )}
                        </span>
                      </Col>
                    </Row>
                  </Grid>
                </Col>
              </Row>
            </Grid>
          </>
        )}
      </Formik>
    </Loader>
  );
}
